function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.693555,
  y: 1.35176,
  width: 24.028,
  height: 24.028,
  rx: 4.575,
  stroke: "currentColor",
  strokeWidth: 0.85
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.33849 10.7608H9.44449V17.4668H8.33849V10.7608ZM8.88449 9.1928C8.66049 9.1928 8.48316 9.13213 8.35249 9.0108C8.23116 8.88013 8.17049 8.71213 8.17049 8.5068C8.17049 8.29213 8.23116 8.12413 8.35249 8.0028C8.48316 7.87213 8.66049 7.8068 8.88449 7.8068C9.10849 7.8068 9.28583 7.87213 9.41649 8.0028C9.55649 8.12413 9.62649 8.29213 9.62649 8.5068C9.62649 8.71213 9.55649 8.88013 9.41649 9.0108C9.28583 9.13213 9.10849 9.1928 8.88449 9.1928ZM12.5361 12.0628C12.9748 11.0921 13.7261 10.6068 14.7901 10.6068C15.5834 10.6068 16.1994 10.8681 16.6381 11.3908C17.0861 11.9135 17.3101 12.6275 17.3101 13.5328V17.4668H16.2181V13.5328C16.2181 12.8888 16.0641 12.4035 15.7561 12.0768C15.4574 11.7501 15.0281 11.5868 14.4681 11.5868C13.9081 11.5868 13.4554 11.8155 13.1101 12.2728C12.7648 12.7301 12.5828 13.3648 12.5641 14.1768V17.4668H11.4581V10.7748H12.4101L12.5361 12.0628Z",
  fill: "currentColor"
});

var SvgLinkedin = function SvgLinkedin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/linkedin.e6990a01.svg";
export { ForwardRef as ReactComponent };